// extracted by mini-css-extract-plugin
module.exports = {"DatastoreScalingStepFormInputNumber":"DatastoreScalingStepFormInputNumber_pQRjS"};